export const TAB_MAILING_LIST_ABOUT = 'mailing_list_about'
export const TAB_MAILING_LIST_RECIPIENT = 'mailing_list_recipient'
